import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {CustomerCareService} from '@api/customer-care.service';
import {animate, animateChild, query, stagger, style, transition, trigger} from '@angular/animations';

@Component({
  selector: 'app-pet-list',
  templateUrl: './pet-list.component.html',
  styleUrls: ['./pet-list.component.scss'],
  animations: [
    trigger('slide', [
      transition('void => *', [
        style({ transform: 'translateX(-100%)', opacity: 0 }),
        animate('0.1s ease-in'),
      ]),
    ]),
    trigger('fade', [
      transition('void => *', [style({ opacity: 0 }), animate(200)]),
    ]),
    trigger('stagger', [
      transition('void => *', [
        query('div', stagger('-.005s ease-in', [animateChild()])),
      ]),
    ])
  ]
})
export class PetListComponent implements OnInit, OnChanges {
  @Input()
  petEntityData: Array<any>;

  searching: boolean = false;

  private pets: Array<{
    petId: string;
    profile: {
      name: string;
      gender?: number;
      breed?: string[];
      imageProfileUrl?: string;
      petType?: string;
      birthday?: string;
      unit?: 'metric' | 'imperial';
      weight?: number;
    };
    tags?: any[];
    technologies?: any[];
    createdAt?: string;
    createdBy?: string;
    updatedBy?: string;
    updatedAt?: string;
    deleted?: boolean;
  }> = [];

  selectedPet;

  constructor(private ccService: CustomerCareService) { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.petEntityData) {
      const petIds: Array<string> = this.petEntityData.map(pet => pet.entityId);
      this.searching = true;
      if (petIds.length > 0) {
        this.ccService.getPetsByPetIds(petIds).subscribe((value) => {
          this.pets = value.data;
          this.searching = false;
        }, (error) => {
          console.log(error);
          this.searching = false;
        });
      }
    }
  }

  petWeight(weight: number, unit: 'metric' | 'imperial'): string {
    if (!weight || !unit) { return 'N/A'; }
    return  weight + (unit === 'metric' ? ' kg' : ' lbs');
  }

}
